/* eslint-disable react/prop-types */
//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').WorkspaceModel>} */

var WORKSPACE_DATA_TYPE = {
  data: {
    url: '/backend/workspacesgrid',
    createItemUrl: '/backend/workspaces',
    itemUrl: '/backend/workspaces?name={id}',
    dataKey: 'workspaces',
    idKeyProp: 'Name',
    filterUrlKey: 'searchName'
  },
  placeholders: {
    label: function label(data) {
      return data.Name;
    },
    type: function type() {
      return 'workspace';
    },
    icon: function icon() {
      return 'workspace';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Workspace',
    formatter: function NameFormatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: "workspace",
        text: data.Name,
        color: "inherit"
      });
    }
  }, {
    id: 'Description',
    formatter: function DescriptionFormatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    }
  }],
  thumbnail: {
    url: function url() {
      return '';
    },
    text: function text(data) {
      return data.Name;
    },
    icon: function icon() {
      return 'workspace';
    }
  },
  contextMenu: [{
    label: 'Manage',
    onClick: function onClick(e, data) {
      return alert('Manage ' + data.Name);
    }
  }, {
    type: 'delete'
  }, 'separator', {
    label: 'View User Permission',
    onClick: function onClick() {
      return alert('View User Permission');
    }
  }]
};
export default WORKSPACE_DATA_TYPE;